import { HttpNoData } from "../../Core";


/**
 * @function getChartOnRange
 * @description Gets laser data for a range of time.
 * @param {string} dateOnly - The date to get data for, in the format 'YYYY-MM-DD'
 * @param {number} range - 0 - week, 1 - month, 2 - year
 * @param {string} jwt - The JSON Web Token to authenticate the request.
 * @returns {Promise<{ 
 *      start: string, 
 *      end: string, 
 *      items: [{ title: string, humidity: number, temperature: number }]}>} - The response data.
 */
export async function getChartOnRange(dateOnly, range, jwt) {

    const response = await HttpNoData(`/api/v1/lasers/range/${dateOnly}/${range}`, 'GET', jwt);

    if (!response.statusSuccessful)
        console.log(response.error);

    return response.data;
}

/**
 * @function getChartOnArbitrary
 * @description Gets laser data for a range of time.
 * @param {string} start - The date to get data for, in the format 'YYYY-MM-DD'
 * @param {string} end - The date to get data for, in the format 'YYYY-MM-DD'
 * @param {string} jwt - The JSON Web Token to authenticate the request.
 * @returns {Promise<{ 
*      start: string, 
*      end: string, 
*      items: [{ title: string, humidity: number, temperature: number }]}>} - The response data.
*/
export async function getChartOnArbitrary(start, end, jwt) {

   const response = await HttpNoData(`/api/v1/lasers/${start}/${end}`, 'GET', jwt);

   if (!response.statusSuccessful)
       console.log(response.error);

   return response.data;
}

/**
 * @function getChartOnAverage
 * @description Gets laser data for a range of time.
 * @param {string} start - The date to get data for, in the format 'YYYY-MM-DD'
 * @param {string} end - The date to get data for, in the format 'YYYY-MM-DD'
 * @param {string} jwt - The JSON Web Token to authenticate the request.
 * @returns {Promise<{ 
*      start: string, 
*      end: string, 
*      info: { title: string, humidity: number, temperature: number }}>} - The response data.
*/
export async function getChartOnAverage(start, end, jwt) {

   const response = await HttpNoData(`/api/v1/lasers/average/${start}/${end}`, 'GET', jwt);

   if (!response.statusSuccessful)
       console.log(response.error);

   return response.data;
}